import {useRouteMatch, Route} from "react-router-dom";
import List from './List';
import Form from './Form';

const Index = () => {
    let {path, url} = useRouteMatch();

    return (
        <>
            <Route exact path={`${path}`} component={List}/>
            <Route path={`${path}/create`} component={Form}/>
            <Route path={`${path}/:id/update`} component={Form}/>
        </>
    )
}

export default Index;
